import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingRefundActionValidation } from 'uplisting-frontend/validations';

export default class BookingRefundActionRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking-refund-action']
> {
  recordName = 'booking-refund-action';
  implementMethods = ['createRecord', 'buildChangeset'];

  validation = BookingRefundActionValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking-refund-action': BookingRefundActionRepositoryService;
  }
}
